/**
 * PlatformAuthContext — session state khusus Platform Owner.
 *
 * Cookie access_token dishare dengan admin/customer, tapi role di JWT-nya
 * `platform_owner`. Backend enforce role gate di setiap /api/platform/* endpoint.
 * Kami TIDAK menyentuh admin/customer AuthContext supaya tidak breaking.
 */
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

const PlatformAuthContext = createContext({
  user: null,
  loading: true,
  login: async () => {},
  logout: async () => {},
  reload: async () => {},
});

export function PlatformAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    try {
      const r = await api.get("/platform/auth/me");
      setUser(r.data);
    } catch { setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/platform/auth/login", { email, password });
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/platform/auth/logout"); } catch (_err) { /* ignore */ }
    setUser(null);
  }, []);

  const value = useMemo(() => ({ user, loading, login, logout, reload }), [user, loading, login, logout, reload]);
  return <PlatformAuthContext.Provider value={value}>{children}</PlatformAuthContext.Provider>;
}

export function usePlatformAuth() { return useContext(PlatformAuthContext); }
